export const Homework = {
     "生成个人作业":"Create Personal homework",
     "生成小组作业":"Create group homework",
     "小组作业":"Group",
     "个人作业":"Personal",
     "评审型作业":"Review type",
     "查重警戒值":"Warning value of duplicate checking",
     "共":"",
     "人":" members in the group",
     "暂无学号":"No student ID",
     "提交时间":"Submission time: ",
     "超":"T",
     "查重":"Duplicate checking",
     "未交":"Uncommitted",
     "已催交":"| Expedited",
     "次":"",
     "打回时间":"| Return time",
     "成员":"",
     "提交状态":"Submission status",
     "正常":"Normal",
     "超时交":"Timeout",
     "字数":"Number of words",
     "第一次作业":"First homework",
     "创建于2020/01/09 12:09":"Created at 12:09, 2020/01/09",
     "已阅":"Read",
     "查重设置":"Duplicate checking setting",
     "是否查重":"Duplicate checking",
     "未填写":"Not filled in",
     "查重率高过上限自动打回":"Automatic return when the duplicate checking rate is higher than the upper limit",
     "查重率上限":"Upper limit of duplicate checking rate",
     "截至时间设置":"Deadline setting",
     "是否限制截止时间":"Whether to limit the deadline",
     "日期":"Date",
     "若超时禁止提交":"If overtime, submit is prohibited",
     "具体时间":"Specific time",
     "选择日期":"Select date",
     "满分值":"Full score",
     "总分设置":"Total score setting",
     "新建个人作业":"New personal homework",
     "新建小组作业":"New group homework",
     "作业标题":"Homework title",
     "作业详情":"Homework details",
     "未开启查重":"No duplication check",
     "开启查重":"Duplicate checking",
     "小组批次":"Group batch",
     "个人":"Personal",
     "小组":"Group",
     "请选择截止时间":"Please select the deadline",
     "分值设置":"Score setting",
     "评语要求":"Requirements for comments:",
     "至少":"at least",
     "字":"word",
     "批阅设置":"Approval settings",
     "批阅人":"Reviewer",
     "作业批阅分配方式":"Assignment method of homework review",
     "每份作业一个人批阅":"Each assignment shall be reviewed by one person",
     "每份作业随机":"Each assignment shall be reviewed by ",
     "人批阅":"person at random",
     "匿名评审":"Anonymous review",
     "评审批阅时学生信息匿名展示":"Anonymous display of student information during review",
     "评分方式":"Scoring method",
     "取平均值":"Average",
     "去掉最高分和最低分取平均值":"Remove the highest and lowest scores and take the average",
     "筛选":"Screen",
     "批阅状态":"Approval status:",
     "条数据":"data",
     "暂时无数据":"No data temporarily~",
     "全选本页":"Select this page all",
     "催交":"Expedite",
     "请确认是否要催交作业":"Please confirm whether to expedite the work?",
     "不催了":"No hurry",
     "立即催交":"Expedite immediately",
     "共选择了":"Select",
     "等共":", etc",
     "学生催交的学生将会收到催交信息":"students, expedited students will receive the expedited information",
     "位":"person",
     "组":"group",
     "已批组":"Corrected groups",
     "未批组":"Uncorrected groups",
     "未交组":"Unsubmit group",
     "催交成功":"Expediting succeeded",
     "提交作业":"Submit homework",
     "更新提交":"Update submission",
     "更新提交被打回":"Update submission (returned)",
     "查看批阅":"View reviews",
     "请先加入小组":"Please join the group first",
     "完成本次小组作业需要先参与进行本次作业所要求的分组任务并加入某一小组":"To complete this group work, you need to participate in the group tasks required by this work and join a group.",
     "重置":"Reset",
     "按时交":"Submit on time",
     "整体查重率":"Overall repetition rate",
     "文件列表":"File list",
     "点击文件可查看重复段落每次作业":"Click the file to view the repeated paragraphs,each homework ",
     "点击文件可查看重复段落每个文档":"Click the file to view the repeated paragraphs,each document ",
     "仅有一次机会":"only have one chance",
     "有5次机会":"five chances",
     "有10次机会":"ten chances",
     "查重率":"Repetition rate",
     "确定使用查看重复段落的机会吗":"Are you sure to use the opportunity to view repeated paragraphs?",
     "本次作业只有1次查看1个文件的机会":"This homework has only one opportunity to view one file",
     "本次作业只有 1 次查看机会并且只能查看所有提交的文件中的 1 个附件文件的重复段落请慎重决定":"There is only one viewing opportunity for each job, and only one duplicate paragraph of an attachment file in all submitted files can be viewed. Please make a careful decision!",
     "作业查重信息":'Duplicate checking',
     "查重规则":"Rules",
     "仍要查看":"Still want to view",
     "已无查看重复段落的机会":"There is no chance to view repeated paragraphs!",
     "查看重复片段机会已用完":"There is no chance to view repeated paragraphs!",
     "文件格式不支持查重":"The file format does not support duplicate checking",
     "暂无重复段落":"No repeated paragraph",
     "表示查重还没有完毕其他同学还未提交作业文件格式不支持查看视频和图片":"Indicates that the duplicate check has not been completed; Other students have not submitted their homework; File format does not support viewing (videos and pictures)",
     "查重率是动态变化的任何同学新提交的作业都会导致查重率的改变有多个文档时以最大查重率文档为基准字数也是一样的规则":"The duplicate checking rate is dynamic, and any new homework submitted by students will lead to the change of the duplicate checking rate. When there are multiple documents, the rule of word count is the same based on the maximum duplicate checking rate document.",
     "给分":"Grade",
     "打回":"Return",
     "请确认是否要打回作业":"Are you sure to return the assignment?",
     "学生的作业":"student's homework",
     "选填打回理由":"(Optional) Reason for return",
     "批量给分":"Batch grade",
     "请输入分数":"Please enter a score",
     "请至少勾选一个作业":"Please check at least one assignment",
     "对学生隐藏成绩":"Hide grades from students",
     "审评截止":"Review deadline:",
     "批量操作":"Batch operation",
     "再次催交":"Expedite again",
     "移动端暂不支持批阅请前往电脑端查看批阅详情":"The mobile terminal does not support approval temporarily. Please go to the computer terminal to check the approval details",
     "已显示":"Displayed",
     "已隐藏":"Hidden",
     "批阅作业":"Correct homework",
     "批阅":"Correct",
     "未批阅":"Uncorrected",
     "批阅小组作业":"Correct group work",
     "统一给分":"Unified score",
     "老师评语":"Teacher's comments",
     "请输入对学生的评语":"Please enter your comments on the student",
     "学生作业":"Student homework",
     "提交历史":"Submission history",
     "手机仅支持浏览请在电脑端添加批注":"Mobile phone only supports browsing, please add annotations on the computer side",
     "查看批注":"view annotation",
     "学生留言":"Student message",
     "暂无留言":"No message",
     "上一位":"Previous",
     "上一组":"Previous",
     "下一位":"Next",
     "下一组":"Next",
     "打回学生作业":"Return student's homework",
     "分享学生作业":"Share students' homework",
     "分享小组作业":"Share group homework",
     "已批阅的同学才能看到防止抄袭":"Only the students who have reviewed can see it, so as to prevent plagiarism",
     "匿名分享名称显示为***学生":"Share anonymously, and the name is displayed as (* * * student)",
     "匿名分享名称显示为***小组":"Share anonymously, and the name is displayed as (* * * group)",
     "选填分享理由":"(Optional) Share reasons...",
     "给学生打分":"Grade students",
     "请打分":"Please grade",
     "作业批阅":"Homework correction",
     "取消分享":"Cancel sharing",
     "发表成功":"Publish successfully",
     "成绩已变更":"Score changed",
     "已分享":"Shared",
     "确认取消分享该作业":"Are you sure you want to cancel sharing this homework?",
     "已取消分享":"Sharing canceled",
     "这是第一个学生作业":"This is the first",
     "已经是最后一个学生作业":"It is the last",
     "组长":"Group leader",
     "暂无小组成员":"No group members~",
     "已交名单":"List submitted",
     "作业提交成功请耐心等待老师批阅":"The assignment was submitted successfully. Please wait patiently for the teacher's correction",
     "作业被老师打回请重新上传":"The homework was returned by the teacher, please upload it again",
     "打回理由":"Reason for return",
     "已批阅成绩未发布":"Corrected, score not published",
     "已批阅，成绩":"Corrected,score ",
     "查看重复率":"View repetition rate",
     "系统默认查看":"*View by default",
     "已分享作业":"Homework shared",
     "提交详情":"Submission details",
     "看谁交了":"Who submitted",
     "课后作业":"Homework",
     "作业附件":"Homework attachment",
     "作业留言":"Homework message",
     "支付单次查重费用":"Pay for one duplicate check",
     "确定支付":"Pay",
     "开通会员每月低至2元即可无限查重":"Join VIP, as low as 2 yuan per month, and unlimited duplicate checking is available >>",
     "元次":"/time",
     "立即提交":"Submit now",
     "立即提交已超时":"Submit now (timed out)",
     "重新提交":"Resubmit",
     "重新提交已超时":"Resubmit (timed out)",
     "更新提交已超时":"Update submission (timed out)",
     "查看作业":"View homework",
     "温馨提醒":"Warm reminder",
     "确定要更新作业吗":"Are you sure to update the homework",
     "当前时间已超过作业提交截止时间重新提交的作业将被标为超时交":"The current time has exceeded the deadline for submitting the job. The resubmitted job will be marked as overtime.",
     "去更新":"Update",
     "更新作业":"Update homework",
     "更新作业并提交之后作业的提交时间将以现在的时间为准":"After the homework is updated and submitted, the submission time of the homework will be subject to the current time!",
     "此功能仅对VIP用户开放开通VIP后可实时查看同班同学提交作业的情况另外还可享受更多VIP权益":"This function is only open to VIP users. After joining VIP, you can view the homework submitted by your classmates in real time. In addition, you can enjoy more VIP benefits",
     "支付成功":"Payment succeeded",
     "小组成员":"Group members",
     "提交次数":"Number of submissions",
     "暂无作业提交":"No homework submission ~",
     "分享理由":"Share reasons",
     "暂无分享作业":"No sharing homework~",
     "系统默认查重":"*System default duplicate checking",
     "添加作业":"Add homework",
     "作业必须以附件的方式提交":"*The homework must be submitted as an attachment",
     "添加留言作业要以附件的形式提交而不是写在留言里":"Add a message,the homework should be submitted as an attachment, not written in the message",
     "提交完成":"Submission completed",
     "正在保存答案请稍后提交":"Saving answers, please submit later",
     "题未作答是否提交":"question not answered, do you want to submit?",
     "继续提交":"Continue submitting",
     "再等等":"Later",
     "您已选择":"You have selected",
     "项少选了":"item, less select",
     "AI批阅评语":"AI correction comments",
     "参考答案设置":"Reference Answer Settings",
     "答案内容":"Answer Content",
     "参考答案附件":"Reference Answer Attachments",
     "答案公布时间":"Answer Publish Time",
     "不设置":"Not Set",
     "作业参考答案":"Homework Reference Answer",
     "答案将于指定时间公布":"Answer will be published at {time}",
     "高级问题作业":"Advanced Problem",
     "总题目":"Problem",
     "进度":"Progress",
     "步骤":"Step",
     "得分":"Score",
     "最终得分":"Final Score",
     "AI追问":"AI Follow-up",
     "本步尚未通过":"This step was not passed",
     "本步得分":"Step score",
     "本步评语":"Step feedback",
     "追问进度":"Follow-ups {current}/{max}",
     "追问后请修改回答再提交":"Revise your answer below based on the AI follow-up, then tap \"Resubmit step\". You will advance after max follow-ups.",
     "请根据评语修改回答再提交":"Revise your answer based on the feedback above, then tap \"Resubmit step\".",
     "再次提交本步":"Resubmit step",
     "修改回答后再次提交":"After revising your answer, tap \"Resubmit step\" below",
     "本步尚未通过请修改后再提交":"This step was not passed. Review the feedback and revise your answer before resubmitting.",
     "AI学习助手":"AI Learning Assistant",
     "我的回答":"My answer",
     "请输入你的回答":"Enter your answer",
     "暂存":"Save Draft",
     "提交本步":"Submit Step",
     "已完成全部步骤":"All steps completed",
     "已暂存":"Draft saved",
     "暂存失败":"Failed to save draft",
     "提交失败请重试":"Submit failed, please retry",
     "AI助手暂不可用":"AI assistant unavailable, answer directly",
     "正在加载AI助手":"Loading AI assistant...",
     "AI助手VIP未开通学生提示":"AI assistant is unavailable. Please ask your instructor to activate the AI Agent Platform.",
     "AI助手VIP过期学生提示":"AI assistant is unavailable. Please ask your instructor to renew the AI Agent Platform.",
     "智能体平台未开通提示":"Advanced problem homework requires the AI Agent Platform. Please activate it first.",
     "智能体平台已失效提示":"The AI Agent Platform has expired. Please renew it first.",
     "AI助手使用说明":"Discuss ideas with AI; write your formal answer in the Answer tab and click Submit Step",
     "AI助手欢迎语":"Hi! We are working on step 「{stepTitle}」. Do not rush for the answer—share your thoughts or where you are stuck, even a small intuition, and I will guide you step by step.",
     "AI助手快捷提问_1":"I am not sure what this step is asking",
     "AI助手快捷提问_2":"I have an idea but I am not sure if it is right",
     "AI助手快捷提问_3":"Give me a hint without the direct answer",
     "回答公式说明":"Markdown and LaTeX supported. Tap Preview to see the rendered result.",
     "作答":"Answer",
     "AI助手":"AI Assistant",
     "预览":"Preview",
     "返回编辑":"Back to edit",
     "点击返回编辑":"Tap here to edit",
     "收起预览":"Hide preview",
     "继续作答":"Continue",
     "查看作答":"View answer",
     "进入作答":"Start answering",
     "教师评语":"Teacher comment",
     "移动端暂不支持高级问题批阅请前往电脑端":"Reviewing advanced problem homework is not supported on mobile. Please use the desktop version.",
     "高级问题作业请在电脑端配置":"Please configure and review advanced problem homework on the desktop version",
     "当前步骤":"Current Step",
     "已完成步骤":"Completed Steps",
     "展开题目":"Expand Problem",
     "收起题目":"Collapse Problem",
     "本步要求":"Step Requirement",
     "插入公式":"Insert formula",
     "公式输入占位":"Enter LaTeX, e.g. \\frac{a}{b} or x^{2}",
     "块级公式":"Display mode (centered)",
     "插入":"Insert",
     "取消":"Cancel",
}
